const _prefix = '@message/';

export default {
  UPDATE_PAGE_TITLE_REQUEST: _prefix + 'UPDATE_PAGE_TITLE_REQUEST',

  UPDATE_TERM_OF_USAGE_REQUEST: _prefix + 'UPDATE_TERM_OF_USAGE_REQUEST',
  UPDATE_TERM_OF_USAGE_SUCCESS: _prefix + 'UPDATE_TERM_OF_USAGE_SUCCESS',
  UPDATE_TERM_OF_USAGE_ERROR: _prefix + 'UPDATE_TERM_OF_USAGE_ERROR',

  GET_SECTION_TITLE_DESCRIPTION_REQUEST: _prefix + 'GET_SECTION_TITLE_DESCRIPTION_REQUEST',
  GET_SECTION_TITLE_DESCRIPTION_SUCCESS: _prefix + 'GET_SECTION_TITLE_DESCRIPTION_SUCCESS',
  GET_SECTION_TITLE_DESCRIPTION_ERROR: _prefix + 'GET_SECTION_TITLE_DESCRIPTION_ERROR',

  GET_TABLE_HEADING_REQUEST: _prefix + 'GET_TABLE_HEADING_REQUEST',
  GET_TABLE_HEADING_SUCCESS: _prefix + 'GET_TABLE_HEADING_SUCCESS',
  GET_TABLE_HEADING_ERROR: _prefix + 'GET_TABLE_HEADING_ERROR',

  UPDATE_TITLE_DESCRIPTION_REQUEST: _prefix + 'UPDATE_TABLE_DESCRIPTION_REQUEST',

  UPDATE_TABLE_HEADING_REQUEST: _prefix + 'UPDATE_TABLE_HEADING_REQUEST',

  GET_TAB_PAGE_TITLE_REQUEST: _prefix + 'GET_TAB_PAGE_TITLE_REQUEST',
  GET_TAB_PAGE_TITLE_SUCCESS: _prefix + 'GET_TAB_PAGE_TITLE_SUCCESS',

  UPDATE_TAB_PAGE_TITLE_REQUEST: _prefix + 'UPDATE_TAB_PAGE_TITLE_REQUEST',

  UPDATE_ALL_TABLE_HEADINGS: _prefix + 'UPDATE_ALL_TABLE_HEADINGS',
  UPDATE_ALL_SECTION_DETAILS: _prefix + 'UPDATE_ALL_SECTION_DETAILS',
  INDEX_ALL_DATA_TO_ELASTICSEARCH: _prefix + 'INDEX_ALL_DATA_TO_ELASTICSEARCH',

  // Preview
  UPDATE_TERM_PREVIEW: _prefix + 'UPDATE_TERM_PREVIEW',
  UPDATE_PAGE_TITLE_PREVIEW: _prefix + 'UPDATE_PAGE_TITLE_PREVIEW',
  UPDATE_TAB_TITLE_PREVIEW: _prefix + 'UPDATE_TAB_TITLE_PREVIEW',
  UPDATE_HEADING_TABLE_PREVIEW: _prefix + 'UPDATE_HEADING_TABLE_PREVIEW',
  UPDATE_SECTION_DETAIL_PREVIEW: _prefix + 'UPDATE_SECTION_DETAIL_PREVIEW',
  UPDATE_ALL_PREVIEW: _prefix + 'UPDATE_ALL_PREVIEW'
};
